import { sharedService } from "@/modules/shared/store/services/shared-service";
import { RECEIVE_GET_GUARANTEES } from "@/redux/constants/parameters";
import { LENDING_PARAMETER_GUARANTEES } from "@/utils/applicationConstants";

/**
 * Guarantees are built from a static constant — no API call needed.
 * We use `queryFn` to synchronously produce the data and bridge it
 * into the existing `state.guarantees` reducer via `onQueryStarted`.
 */
const getGuarantees = sharedService.injectEndpoints({
  endpoints: builder => ({
    getGuarantees: builder.query({
      queryFn: () => {
        const guarantees = Object.keys(LENDING_PARAMETER_GUARANTEES).map(key => ({
          value: key,
          label: LENDING_PARAMETER_GUARANTEES[key],
        }));
        return { data: guarantees };
      },
      providesTags: ["Guarantees"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch({ type: RECEIVE_GET_GUARANTEES, guarantees: data });
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetGuaranteesQuery } = getGuarantees;


